import { hasValue, log, Memoize } from "@repo/helpers";
import { MouseEvent } from "react";

import DynamicEditorContainer from "./container";
import { DynamicEditorMobile as MobileView } from "./mobileEditor";
import { MappedSection } from "./models/mappedComponent";
import { Props, WrapperProps } from "./types";
import WebView from "./webView";

export default function DynamicEditor(props: WrapperProps) {
	const { validationResults, templateData, ...rest } = props;
	return (
		<DynamicEditorContainer validationResults={validationResults} templateData={templateData} {...rest}>
			<InternalMemo {...rest} />
		</DynamicEditorContainer>
	);
}

const InternalMemo = Memoize(Internal, ["getCustomComponent"], false);

function Internal(props: Props) {
	if (props.mobileView) return <MobileView {...props} />;
	return <WebView {...props} />;
}

export function scrollToField(event: MouseEvent) {
	const propertyName = event.currentTarget.getAttribute("data-field");

	scrollToPropertyName(propertyName);
}

export function scrollToPropertyName(propertyName: string) {
	if (propertyName[propertyName.length - 1] === ".") {
		document.getElementById(propertyName.substring(0, propertyName.length - 1)).scrollIntoView();
	} else {
		const element = document.querySelector(`label[for='${propertyName}']`);
		if (element === null) return false;
		element.scrollIntoView();
		const control = document.getElementById(propertyName);
		if (control) control.focus();
	}
	return true;
}

/**
 * Returns true if section is visible, and has visible children
 * @param section
 * @returns
 */
export function sectionIsVisible(section: MappedSection) {
	return (
		section.visible && (section.components.some((c) => c.visible) || section.childSections.some(sectionIsVisible))
	);
}
/**
 * Scroll to subsection with id
 * @param subsection id of a section to scroll to
 */
export function scrollToSubsection(subsection: string) {
	const el = (document.querySelector(`div[data-subsection='${subsection}']`) ||
		document.querySelector(`label[for='${subsection}']`) ||
		document.getElementById(subsection)) as HTMLElement;

	if (el) {
		el.scrollIntoView();
		el.focus();
	} else {
		log(`No element matching subSection ${subsection} found.  Could not scroll to`);
	}

	return hasValue(el);
}
